// extracted by mini-css-extract-plugin
module.exports = {"activeSidebar":"sX","pageLayout":"tX","mainContent":"uX"};